import { GET_GL_ACCOUNT_CODES, GET_GL_ACCOUNT_CODE_SAVE, SET_GL_ACCOUNT_CODES, SET_GL_ACCOUNT_CODE_SAVE } from "./GLAccountCodesType"

const getGLAccountCodes = () => ({
    type : GET_GL_ACCOUNT_CODES,
})

const setGLAccountCodes = (codes: any) => ({
    type : SET_GL_ACCOUNT_CODES,
    codes : codes
})

const getGLAccountCodeSave = (payload: any) => ({
    type: GET_GL_ACCOUNT_CODE_SAVE,
    payload
})

const setGLAccountCodeSave = (glAccountCodeSave: any) => ({
    type: SET_GL_ACCOUNT_CODE_SAVE,
    glAccountCodeSave: glAccountCodeSave
})

export {
    getGLAccountCodes,
    setGLAccountCodes,
    getGLAccountCodeSave,
    setGLAccountCodeSave
}